import type { ReactNode } from 'react'

import { Text } from '@mantine/core'
import { ChevronDown, ChevronRight } from 'lucide-react'

import DNButton from 'src/components/Buttons/Button/DNButton'

/**
 * The uppercase grey section name the drawers share, with an optional link at
 * the right. Given `onToggle`, the name folds the section to this one line.
 */
export const SectionTitle = ({
  children,
  action,
  folded = false,
  onToggle,
}: {
  children: ReactNode
  action?: ReactNode
  folded?: boolean
  onToggle?: () => void
}) => {
  const title = (
    <Text size="xs" fw={400} className="uppercase text-doubleNickel-gray-500">
      {children}
    </Text>
  )
  return (
    <div className="flex flex-row items-center justify-between">
      {onToggle ? (
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={!folded}
          className="flex cursor-pointer items-center gap-1 rounded text-doubleNickel-gray-500 hover:text-doubleNickel-gray-700"
        >
          {folded ? <ChevronRight size={14} /> : <ChevronDown size={14} />}
          {title}
        </button>
      ) : (
        title
      )}
      {action}
    </div>
  )
}

export const SectionLink = ({
  children,
  onClick,
}: {
  children: ReactNode
  onClick: () => void
}) => (
  <DNButton variant="link" onClick={onClick} className="px-1 py-0.5">
    {children}
  </DNButton>
)

/** Right-aligned buttons that close a stage. */
export const StageActions = ({ children }: { children: ReactNode }) => (
  <div className="flex flex-row justify-end gap-2 pt-1">{children}</div>
)
